import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { FlexBox } from '../../box';
import { IconDistance, IconLocationOn } from '../../icon';
import { Typography } from '../../typography';
export const facilityValueTypography = {
    maxWidth: 250,
    fontWeight: 500
};
export const FacilityValue = React.forwardRef((props, ref) => {
    const Icon = props.topNav ? IconDistance : IconLocationOn;
    return (_jsxs(FlexBox, { ref: ref, gap: 0.5, vAlign: "center", height: "100%", sx: { ...props.sx, pointerEvents: 'none' }, children: [_jsx(Icon, { color: "components.facility.contrast.icon", filled: props.filled, fontSize: "small", ref: props.onIconRef }), !props.reduced && (_jsx(Typography, { ...facilityValueTypography, noWrap: true, color: props.topNav
                    ? 'components.facility.contrast.text-top-navigation'
                    : 'components.facility.contrast.text', textTransform: "sentence", children: props.children }))] }));
});
